module.exports = __webpack_public_path__ + "img/news-nav-icon-4.40ed5817.png";